module.exports = __webpack_public_path__ + "static/media/new-car-banner-mobile.47d7a580.jpg";